module.exports = __webpack_public_path__ + "static/img/logo.236e90f7.png";